import type { USER_ROLES } from "@onesolution/constants";

import useUserInfos from "./useUserInfos";

export default function useIsUserInRoles(roles: USER_ROLES[]) {
	const userInfos = useUserInfos();

	return userInfos.roles.some((role) =>
		roles.some((isRole) => `OS-${isRole}` === role),
	);
}
